import { render, staticRenderFns } from "./EocViewSummaryNextAppointments.vue?vue&type=template&id=0fb9f72e&"
import script from "./EocViewSummaryNextAppointments.vue?vue&type=script&lang=js&"
export * from "./EocViewSummaryNextAppointments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports